{{ 'form-builder.legos.listing.header' | translate | titlecase }}
<div class="mct-flex mct-col mct-gap-27"   *ngIf="listingData">
  <div *ngIf="listingData.DisplayCategory">
    <label>{{
      listingData.CategoryLabel ? listingData.CategoryLabel : ('form-builder.legos.listing.listing-category' | translate | ucfirst)
    }}</label>
    <p-select [style]="{ width: '100%' }" appendTo="body"></p-select>
  </div>
  <div *ngIf="listingData.DisplaySubCategory">
    <label>{{
      listingData.SubCategoryLabel ? listingData.SubCategoryLabel : ('form-builder.legos.listing.listing-subcategory' | translate | ucfirst)
    }}</label>
    <p-select [style]="{ width: '100%' }" appendTo="body"></p-select>
  </div>
  <div *ngIf="listingData.DisplayLongDescription">
    <label>{{
      listingData.LongDescriptionLabel
        ? listingData.LongDescriptionLabel
        : ('form-builder.legos.listing.long-description' | translate | ucfirst)
    }}</label>
    <textarea class="form-control"></textarea>
  </div>
  <div *ngIf="listingData.DisplayShortDescription">
    <label>{{
      listingData.ShortDescriptionLabel
        ? listingData.ShortDescriptionLabel
        : ('form-builder.legos.listing.short-description' | translate | ucfirst)
    }}</label>
    <textarea class="form-control"></textarea>
  </div>
  <div *ngIf="listingData.DisplayKeywords">
    <label>{{
      listingData.KeywordsLabel ? listingData.KeywordsLabel : ('form-builder.legos.listing.keywords' | translate | ucfirst)
    }}</label>
    <textarea class="form-control"></textarea>
  </div>
  <div *ngIf="listingData.AllowAdditional">
    <button pButton type="button" class="atlas-btn atlas-btn-primary">
      {{ 'form-builder.legos.listing.add-additional-listing' | translate | titlecase }}
    </button>
    {{ listingData.PricePerAdditional | currency }}
  </div>
</div>
